import React from "react";
import DocumentPreview from "components/DocumentPreview";
import DocumentActions from "../VideoActions/DocumentActions";
import UserPlaceholder from "assets/img/user.png";
import RoundLogo from "assets/img/ic_launcher_round.png";
import { extractFileName } from "utils/helpers";

const LinkIconSVG = ({ size = 32 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
);

const ExternalArrowSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="7" y1="17" x2="17" y2="7"></line>
    <polyline points="7 7 17 7 17 17"></polyline>
  </svg>
);

const DocumentListItem = ({
  v,
  showDefaultAvatar,
  iDx,
  allowActions,
  showAction,
  setReload,
  onUpdate,
}) => {
  const displayLink = v.link
    ? v.link.replace(/^https?:\/\//, "").replace(/\/$/, "")
    : null;
  const linkHref = v.link
    ? v.link.startsWith("http")
      ? v.link
      : `https://${v.link}`
    : null;

  return (
    <div key={`${iDx}-${v.title}`} className="documentListContainerItem">
      <div className="documentItemImage">
        {v.thumbnail ? (
          /* ── Thumbnail preview ── */
          <div className="thumbnailWithPreview">
            {v.link ? (
              <a
                href={linkHref}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "block", width: "100%", height: "100%" }}
              >
                <img
                  src={v.thumbnail}
                  alt="Thumbnail"
                  className="documentThumbnailImg"
                />
                <div
                  className="previewOverlay"
                  style={{ display: "flex", justifyContent: "center", paddingBottom: "0.8rem" }}
                >
                  <span
                    className="docLinkOpenLabel"
                    style={{
                      margin: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                      padding: "6px 16px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                      border: "1px solid rgba(255,161,0,0.5)",
                    }}
                  >
                    Open Link&nbsp;<ExternalArrowSVG />
                  </span>
                </div>
              </a>
            ) : (
              <>
                <img
                  src={v.thumbnail}
                  alt="Thumbnail"
                  className="documentThumbnailImg"
                />
                <div className="previewOverlay">
                  <DocumentPreview
                    expression={{
                      media: v.url,
                      media_name: extractFileName(v.url),
                    }}
                  />
                </div>
              </>
            )}
          </div>
        ) : v.link ? (
          /* ── Link card preview ── */
          <a
            href={linkHref}
            target="_blank"
            rel="noopener noreferrer"
            className="docLinkPreview"
          >
            <div className="docLinkIconWrap">
              <LinkIconSVG size={28} />
            </div>
            <span className="docLinkUrl">{displayLink}</span>
            <span className="docLinkOpenLabel">
              Open Link&nbsp;<ExternalArrowSVG />
            </span>
          </a>
        ) : (
          /* ── File document preview ── */
          <DocumentPreview
            expression={{
              media: v.url,
              media_name: extractFileName(v.url),
            }}
          />
        )}
      </div>

      {v?.is_forwarded && (
        <div className="documentSharedBy">
          <img
            height={16}
            width={16}
            src={v?.original_post?.user?.avatar ?? UserPlaceholder}
            alt=""
            className="documentSharedByAvatar"
          />
          <span>
            Shared by {v?.original_post?.user?.first_name}{" "}
            {v?.original_post?.user?.last_name}{" "}
            {v?.original_post?.team?.name && (
              <>from{" "} {v?.original_post?.team?.name}</>
            )}
          </span>
        </div>
      )}

      <div className="documentActionContainer">
        <div className="d-flex gap-1 align-items-center">
          <img
            src={
              showDefaultAvatar ? RoundLogo : v?.user?.avatar ?? UserPlaceholder
            }
            alt=""
            height={38}
            width={38}
            className="documentUserAvtar"
          />
          <div className="d-flex flex-column">
            <div className="documentTitle">{v.title}</div>
            {v.short_desc && (
              <div className="documentDesc">{v.short_desc}</div>
            )}
          </div>
        </div>

        {allowActions && showAction && (
          <DocumentActions
            documentId={v.id}
            document={v}
            setReload={setReload}
            onUpdate={onUpdate}
            isForwarded={v?.is_forwarded}
          />
        )}
      </div>
    </div>
  );
};

export default DocumentListItem;
